import api from '../api';

export default {
    async getPortalCertificates(accessToken) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get('/portal/certificate', { headers });
            return response.data;
        } catch (error) {
            console.error('Error fetching portal certificates:', error);
            throw error;
        }
    },
}